export default {
  dashboard: 'Dashboard',
  newOrder: 'Create order',
  inboxes: 'Inboxes',
  invoiceReports:'Reports',
  welcome: 'Welcome, {name}!'
}